import { createObservableOperation } from 'owa-observable-operation';
import fetchListUserFeatureAccess from '../services/fetchListUserFeatureAccess';
import { ListUserFeatureAccessKey } from '../constants/constants';
import type { Features } from 'owa-graph-schema';
import type { TraceErrorObject } from 'owa-analytics-types';

const dest = createObservableOperation(
    'PLACES_ANALYTICS_LOAD_EVENTS_FOR_LIST_USER_FEATURE_ACCESS',
    () => ({}),
    () => ListUserFeatureAccessKey,
    () => fetchListUserFeatureAccess()
);
const startListUserFeatureAccess: () => {} = dest.start;
const loadListUserFeatureAccessInProgress: (key: 'LIST_USER_FEATURE_ACCESS_KEY') => boolean =
    dest.isInProgress;
const getListUserFeatureAccessLastError: (
    key: 'LIST_USER_FEATURE_ACCESS_KEY'
) => TraceErrorObject | undefined = dest.getLastError;
const loadListUserFeatureAccessSucceeded: (actionMessage: { result: (Features | null)[] }) => {
    result: (Features | null)[];
} = dest.onSucceeded;

let hasLoadedListUserFeatureAccess = false;

const loadListUserFeatureAccess = (): void => {
    if (!hasLoadedListUserFeatureAccess) {
        startListUserFeatureAccess();
        hasLoadedListUserFeatureAccess = true;
    }
};

export {
    getListUserFeatureAccessLastError,
    loadListUserFeatureAccess,
    loadListUserFeatureAccessInProgress,
    loadListUserFeatureAccessSucceeded,
};
